import { Injectable } from '@angular/core';
import { Observable, throwError, of } from 'rxjs';

import { RestService } from "src/app/service/RestService";
import { environment } from 'src/environments/environment';
import { CommonServiceLocal } from './CommonServiceLocal';
import { HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CommonService extends RestService {
  commonServiceLocal : CommonServiceLocal = new CommonServiceLocal();

  public checkBackURL(url: string): Observable<any> {
    let params = {
      "url": url
    };

    if (environment.env == "local") {
      return this.commonServiceLocal.checkBackURL(url);
    } 
    
    return this.restPost(environment.api.checkBackURL, params);
  }

  public getURL(url: string): Observable<any> {
    let params = {
      "signinURL": url
    };

    if (environment.env == "local") {
      return this.commonServiceLocal.getURL(url);
    } 
    
    return this.restPost(environment.api.getUrl, params);
  }

  public checkAccount(userName: string): Observable<any> {
    let params = {
      "username": userName
    };
    if (environment.env == "local") {
      return this.commonServiceLocal.checkAccount(userName);
    } 

    return this.restPost(environment.api.checkAccount, params);
  }

  public getNotifications(): Observable<any> {
    if (environment.env == "local") {
      return this.commonServiceLocal.getNotifications();
    } 

    const params = new HttpParams();
    const headers = new HttpHeaders();
    return this.restGet(environment.api.getNotifications, headers, params);
  }

  public checkPkiUser(loginEmail: string, handleResult: (result: boolean) => void) {
    console.log("checkPkiUser start");

    let pkiUser = false;
    this.checkAccount(loginEmail).subscribe(
      (response) => {
        console.log("checkPkiUser: checkAccountResponse: " + JSON.stringify(response));
        pkiUser = (response.error_code == 16);
        console.log("checkPkiUser: " + pkiUser);
        handleResult(pkiUser);
      }, (error) => {
        console.log("checkAccount got exception: " + error);
        handleResult(pkiUser);
      });
  }

  // Determine the landing url from given string.
  public static determineSigninUrl(fullResourceUrl: string): string {
    let resourceUrl = null;

    // if resource url received then search of the resource_url within this string
    if (fullResourceUrl) {
      var searchParams = new URLSearchParams(decodeURIComponent(fullResourceUrl));

      resourceUrl = decodeURIComponent(searchParams.get("resource_url"));
      if ((resourceUrl ?? true) && resourceUrl == "null") {
        resourceUrl = fullResourceUrl;
      }
    } else {
      resourceUrl = fullResourceUrl;
    }

    return resourceUrl;
  }

}
